import { Spinner } from '@acorns/web-components'
import styled, { css } from 'styled-components'

import Button from 'components/Button'
import { CTAContainer } from 'components/CTAContainer'
import Separator from 'components/Separator'
import { Body, Footnote, Heading, Heading2, Subheading } from 'components/Typography'
import { style } from 'theme'

export const TextContainer = styled.div<{ fullyResponsivePadding?: boolean }>`
  text-align: center;

  ${props =>
    props.fullyResponsivePadding &&
    css`
      padding-bottom: 80px;

      @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
        padding-bottom: 30px;
      }
    `}

  p:last-child {
    margin-bottom: 0;
  }
`

export const ButtonContainer = styled(CTAContainer)`
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    flex-direction: column;
  }
`

export const Title = styled(Heading2)`
  font-size: 22px;
  line-height: 30px;
  margin-bottom: 6px;
`

export const Message = styled(Body)`
  margin: 0 auto;
  max-width: 340px;
`

export const EmailAddress = styled.span`
  text-decoration: underline;
`

export const EmailConfirmation = styled(Body)`
  font-weight: 500;
  margin-bottom: 20px;
  line-height: 1;
`

export const ChangeEmail = styled(Footnote)`
  font-style: italic;
  line-height: 1;
`

export const ChangeEmailLink = styled.a`
  color: ${style(theme => theme.colors.stone)};
  font-size: 12px;
  font-weight: 400;
  line-height: 1.33;
  margin: 0;
  cursor: pointer;
  text-decoration: underline;
`

export const AppStoreButtons = styled.a`
  cursor: pointer;

  &.full-width {
    background-color: #000000;
    border-radius: 22px;
    display: flex;
    height: 44px;
    justify-content: center;
    margin: 0 auto;
    text-align: center;
    min-width: 220px;

    @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
      width: 100%;
    }
  }
`

export const GreenCopy = styled.span`
  font-weight: 500;
  color: ${style(theme => theme.colors.green)};
`

export const StyledSeparator = styled(Separator)<{ withMargin: boolean }>`
  ${props =>
    props.withMargin &&
    `
      margin-top: 80px;

      @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
          display: none;
      }
  `}
`

export const ChangeEmailButton = styled(Button)`
  margin: 0 10px;
  @media (max-width: ${style(theme => theme.breakpoints.md)}px) {
    min-width: calc(50% - 10px);
  }
`

export const StyledSpinner = styled(Spinner)`
  margin-bottom: 14px;
`

export const PartnerHeading = styled(Heading)`
  text-align: center;
`

export const PartnerSubheading = styled(Subheading)`
  margin-top: 40px;
  text-align: center;
`

export const PartnerLink = styled.a`
  text-decoration: underline;
  cursor: pointer;
`

export const Icon = styled.img`
  margin: 30px auto 20px;
  max-width: 170px;
  max-height: 130px;
`

export const Image = styled.img`
  max-width: 100%;
  max-height: 100%;
`
export const ImageContainer = styled.div`
  height: 100%;
`
export const SuccessIcon = styled.img`
  margin: 30px auto 40px;
  max-width: 250px;
  max-height: 150px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin-bottom: 30px;
  }
`
